import type { Breakpoints } from './types';

const breakpoints: Breakpoints = {
  small: 320,
  medium: 600,
  large: 1136,
};

export default breakpoints;
